import { render } from "./PageNotFound.vue?vue&type=template&id=dd07f6e4&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=dd07f6e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd07f6e4"

export default script